import { render } from "./SettingsBasic.vue?vue&type=template&id=3ea4c8d3&ts=true"
import script from "./SettingsBasic.vue?vue&type=script&lang=ts"
export * from "./SettingsBasic.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./SettingsBasic.vue?vue&type=style&index=0&id=3ea4c8d3&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__